"use client";

import React from "react";

import { BasicButton } from "../components/button/BasicButton";
import { BeginningButton } from "../components/button/BeginningButton";
import { FreeButton } from "../components/button/FreeButton";
import { PremiumButton } from "../components/button/PremiumButton";
import { Plan } from "../types/pricing-tiers";

/**
 * @param plan - The plan key to get the button for
 * @param durationText - The duration text to display on the button
 * @returns The button for the plan
 */
export const getCardButton = ({
  plan,
  durationText,
}: {
  plan: Plan;
  durationText: "Monthly" | "Yearly";
}) => {
  const buttonMap: Record<Plan, React.ReactNode> = {
    free: <FreeButton key="free-plan-button" />,
    beginning: (
      <BeginningButton
        key="beginning-plan-button"
        planType={`Beginning ${durationText}`}
      />
    ),
    basic: (
      <BasicButton key="basic-plan-button" planType={`Basic ${durationText}`} />
    ),
    premium: (
      <PremiumButton
        key="premium-plan-button"
        planType={`Premium ${durationText}`}
      />
    ),
  };

  return buttonMap[plan];
};
